<template>
  <div>
    <div class="top">
      <div class="top-img">
        <img src="./../assets/2024/header.png" alt="对邪教说不">
      </div>
    </div>
    <div class="success">
      <img src="./../assets/2024/share-dialog-icon.png" alt="关注“中国反邪教”公众号">
      <div>
        <p><strong>提示：</strong></p>
        <p>在“<strong>中国反邪教</strong>”微信公众号底部菜单栏</p>
        <p>点击“<strong>签名答题</strong>”</p>
        <p>即可进入系统参与网上签名和答题活动</p>
      </div>
    </div>
  </div>
</template>

<script>
import wechatUtils from "@/api/wechat"
export default {
  name: 'Follow',
  // components: {
  //   HelloWorld
  // }
  data() {
    return {}
  },
  mounted() {
    // const obj = new WxLogin({
    //   "self_redirect": true,
    //   id: "login_container", 
    //   appid: "", 
    //   scope: "", 
    //   "redirect_uri": "",
    //   state: "",
    //   style: "",
    //   href: ""
    // });
    // console.log(obj);
    wechatUtils.config()
  },
}
</script>
<style lang="scss" scoped>

.top-img {
  img {
    max-width: 100%;
  }
}
.success {
  margin: auto;
  display: inline-block;
  margin-top: -24vw;

  img {
    margin-top: 30px;
    max-width: 52%;
    max-height: 100%;
  }
  div {
    width: 80%;
    margin: 10px auto;
    text-align: left;
    padding: 12px;
    background-color: rgba(255, 255, 255, 0.4);
    border-radius: 8px;
    color: #333;
    p {
      font-size: 16px;
      letter-spacing: 1px;
    }
  }
}
</style>
